module.exports = __webpack_public_path__ + "static/media/foot-clinic-collage.9190802d.png";